import { App } from "vue";
import { reactive } from "vue";

import PrimeVue from "primevue/config";
import AutoComplete from "primevue/autocomplete";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Avatar from "primevue/avatar";
import AvatarGroup from "primevue/avatargroup";
import Badge from "primevue/badge";
import BadgeDirective from "primevue/badgedirective";
import Breadcrumb from "primevue/breadcrumb";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import Card from "primevue/card";
import Carousel from "primevue/carousel";
import Chart from "primevue/chart";
import Checkbox from "primevue/checkbox";
import Chip from "primevue/chip";
import Chips from "primevue/chips";
import ColorPicker from "primevue/colorpicker";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import ConfirmDialog from "primevue/confirmdialog";
import ConfirmPopup from "primevue/confirmpopup";
import ConfirmationService from "primevue/confirmationservice";
import ContextMenu from "primevue/contextmenu";
import DataTable from "primevue/datatable";
import DataView from "primevue/dataview";
import DataViewLayoutOptions from "primevue/dataviewlayoutoptions";
import Dialog from "primevue/dialog";
import Divider from "primevue/divider";
import Dropdown from "primevue/dropdown";
import Editor from "primevue/editor";
import Fieldset from "primevue/fieldset";
import FileUpload from "primevue/fileupload";
import Galleria from "primevue/galleria";
import Image from "primevue/image";
import InlineMessage from "primevue/inlinemessage";
import Inplace from "primevue/inplace";
import InputMask from "primevue/inputmask";
import InputNumber from "primevue/inputnumber";
import InputSwitch from "primevue/inputswitch";
import InputText from "primevue/inputtext";
import Knob from "primevue/knob";
import Listbox from "primevue/listbox";
import MegaMenu from "primevue/megamenu";
import Menu from "primevue/menu";
import Menubar from "primevue/menubar";
import Message from "primevue/message";
import MultiSelect from "primevue/multiselect";
import OrderList from "primevue/orderlist";
import OrganizationChart from "primevue/organizationchart";
import OverlayPanel from "primevue/overlaypanel";
import Paginator from "primevue/paginator";
import Panel from "primevue/panel";
import PanelMenu from "primevue/panelmenu";
import Password from "primevue/password";
import PickList from "primevue/picklist";
import ProgressBar from "primevue/progressbar";
import Rating from "primevue/rating";
import RadioButton from "primevue/radiobutton";
import Ripple from "primevue/ripple";
import Row from "primevue/row";
import SelectButton from "primevue/selectbutton";
import ScrollPanel from "primevue/scrollpanel";
import ScrollTop from "primevue/scrolltop";
import Slider from "primevue/slider";
import Sidebar from "primevue/sidebar";
import Skeleton from "primevue/skeleton";
import SpeedDial from "primevue/speeddial";
import SplitButton from "primevue/splitbutton";
import Splitter from "primevue/splitter";
import SplitterPanel from "primevue/splitterpanel";
import Steps from "primevue/steps";
import StyleClass from "primevue/styleclass";
import TabMenu from "primevue/tabmenu";
import TabPanel from "primevue/tabpanel";
import TabView from "primevue/tabview";
import Tag from "primevue/tag";
import TieredMenu from "primevue/tieredmenu";
import Textarea from "primevue/textarea";
import Timeline from "primevue/timeline";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Toolbar from "primevue/toolbar";
import Tooltip from "primevue/tooltip";
import ToggleButton from "primevue/togglebutton";
import Tree from "primevue/tree";
import TreeSelect from "primevue/treeselect";
import TreeTable from "primevue/treetable";
import TriStateCheckbox from "primevue/tristatecheckbox";

import "primevue/resources/primevue.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";

import KoruActionButton from "@/core/components/KoruActionButton/KoruActionButton";
import KoruAddress from "@/core/components/KoruAddress/KoruAddress";
import KoruAddressMap from "@/core/components/KoruAddressMap/KoruAddressMap";
import KoruBlock from "@/core/components/KoruBlock/KoruBlock";
import KoruBreadcrumb from "@/core/components/KoruBreadcrumb/KoruBreadcrumb";
import KoruBrowser from "@/core/components/KoruBrowser/views/KoruBrowser";
import KoruButtonUpload from "@/core/components/KoruButtonUpload/KoruButtonUpload";
import KoruContainer from "@/core/components/KoruContainer/KoruContainer";
import KoruCurrencyField from "@/core/components/fields/KoruCurrencyField/KoruCurrencyField";
import KoruEditor from "@/core/components/KoruEditor/views/KoruEditor";
import KoruExpiration from "@/core/components/KoruExpiration/KoruExpiration";
import KoruFieldValue from "@/core/components/KoruFieldValue/KoruFieldValue";
import KoruImageUpload from "@/core/components/KoruImageUpload/KoruImageUpload";
import KoruLoading from "@/core/components/KoruLoading/KoruLoading";
import KoruMap from "@/core/components/KoruMap/KoruMap";
import KoruMultipleUpload from "@/core/components/KoruMultipleUpload/KoruMultipleUpload";
import KoruNumberField from "@/core/components/fields/KoruNumberField/KoruNumberField";
import KoruPdfDialog from "@/core/components/KoruPdfDialog/KoruPdfDialog";
import KoruPercentField from "@/core/components/fields/KoruPercentField/KoruPercentField";
import KoruPlaces from "@/core/components/KoruPlaces/KoruPlaces";
import KoruProgress from "@/core/components/KoruProgress/KoruProgress";
import KoruSortableBrowser from "@/core/components/KoruSortableBrowser/views/KoruSortableBrowser";
import KoruSplitButton from "@/core/components/KoruSplitButton/KoruSplitButton";
import KoruTabbedViewer from "@/core/components/KoruTabbedViewer/KoruTabbedViewer";
import KoruTinyBrowser from "@/core/components/KoruTinyBrowser/views/KoruTinyBrowser";
import KoruTree from "@/core/components/KoruTree/views/KoruTree";
import KoruUpload from "@/core/components/KoruUpload/KoruUpload";
import KoruViewer from "@/core/components/KoruViewer/KoruViewer";

import { config } from "@/core/modules/config/objects/Config";

import { dePrimevue } from "@/core/locales/primevue/de";
import { enPrimevue } from "@/core/locales/primevue/en";
import { frPrimevue } from "@/core/locales/primevue/fr";
import { itPrimevue } from "@/core/locales/primevue/it";

export class Layout {
  public static init(koruApp: App): void {
    koruApp.config.globalProperties.$appState = reactive({
      inputStyle: "filled",
    });

    let locale = itPrimevue;
    if (config.app.locale.default === "de") locale = dePrimevue;
    if (config.app.locale.default === "en") locale = enPrimevue;
    if (config.app.locale.default === "fr") locale = frPrimevue;

    koruApp.use(PrimeVue, {
      ripple: true,
      locale: locale,
    });

    koruApp.use(ConfirmationService);
    koruApp.use(ToastService);

    koruApp.directive("tooltip", Tooltip);
    koruApp.directive("ripple", Ripple);
    koruApp.directive("badge", BadgeDirective);
    koruApp.directive("styleclass", StyleClass);

    koruApp.directive("capitalize", {
      updated(el) {
        const sourceValue = el.value;
        if (sourceValue != undefined && sourceValue != "") {
          const start = el.selectionStart;
          const newValue = sourceValue.toUpperCase();

          if (sourceValue !== newValue) {
            el.value = newValue;
            el.dispatchEvent(new Event("input", { bubbles: true }));
          }
          el.setSelectionRange(start, start);
        }
      },
    });

    koruApp.component("Accordion", Accordion);
    koruApp.component("AccordionTab", AccordionTab);
    koruApp.component("AutoComplete", AutoComplete);
    koruApp.component("Avatar", Avatar);
    koruApp.component("AvatarGroup", AvatarGroup);
    koruApp.component("Badge", Badge);
    koruApp.component("Breadcrumb", Breadcrumb);
    koruApp.component("Button", Button);
    koruApp.component("Calendar", Calendar);
    koruApp.component("Card", Card);
    koruApp.component("Carousel", Carousel);
    koruApp.component("Chart", Chart);
    koruApp.component("Checkbox", Checkbox);
    koruApp.component("Chip", Chip);
    koruApp.component("Chips", Chips);
    koruApp.component("ColorPicker", ColorPicker);
    koruApp.component("Column", Column);
    koruApp.component("ColumnGroup", ColumnGroup);
    koruApp.component("ConfirmDialog", ConfirmDialog);
    koruApp.component("ConfirmPopup", ConfirmPopup);
    koruApp.component("ContextMenu", ContextMenu);
    koruApp.component("DataTable", DataTable);
    koruApp.component("DataView", DataView);
    koruApp.component("DataViewLayoutOptions", DataViewLayoutOptions);
    koruApp.component("Dialog", Dialog);
    koruApp.component("Divider", Divider);
    koruApp.component("Dropdown", Dropdown);
    koruApp.component("Editor", Editor);
    koruApp.component("Fieldset", Fieldset);
    koruApp.component("FileUpload", FileUpload);
    koruApp.component("Galleria", Galleria);
    koruApp.component("Image", Image);
    koruApp.component("InlineMessage", InlineMessage);
    koruApp.component("Inplace", Inplace);
    koruApp.component("InputMask", InputMask);
    koruApp.component("InputNumber", InputNumber);
    koruApp.component("InputSwitch", InputSwitch);
    koruApp.component("InputText", InputText);
    koruApp.component("Knob", Knob);
    koruApp.component("Listbox", Listbox);
    koruApp.component("MegaMenu", MegaMenu);
    koruApp.component("Menu", Menu);
    koruApp.component("Menubar", Menubar);
    koruApp.component("Message", Message);
    koruApp.component("MultiSelect", MultiSelect);
    koruApp.component("OrderList", OrderList);
    koruApp.component("OrganizationChart", OrganizationChart);
    koruApp.component("OverlayPanel", OverlayPanel);
    koruApp.component("Paginator", Paginator);
    koruApp.component("Panel", Panel);
    koruApp.component("PanelMenu", PanelMenu);
    koruApp.component("Password", Password);
    koruApp.component("PickList", PickList);
    koruApp.component("ProgressBar", ProgressBar);
    koruApp.component("RadioButton", RadioButton);
    koruApp.component("Row", Row);
    koruApp.component("Rating", Rating);
    koruApp.component("SelectButton", SelectButton);
    koruApp.component("ScrollPanel", ScrollPanel);
    koruApp.component("ScrollTop", ScrollTop);
    koruApp.component("Slider", Slider);
    koruApp.component("Sidebar", Sidebar);
    koruApp.component("Skeleton", Skeleton);
    koruApp.component("SpeedDial", SpeedDial);
    koruApp.component("SplitButton", SplitButton);
    koruApp.component("Splitter", Splitter);
    koruApp.component("SplitterPanel", SplitterPanel);
    koruApp.component("Steps", Steps);
    koruApp.component("TabMenu", TabMenu);
    koruApp.component("TabView", TabView);
    koruApp.component("TabPanel", TabPanel);
    koruApp.component("Tag", Tag);
    koruApp.component("Textarea", Textarea);
    koruApp.component("TieredMenu", TieredMenu);
    koruApp.component("Timeline", Timeline);
    koruApp.component("Toast", Toast);
    koruApp.component("Toolbar", Toolbar);
    koruApp.component("ToggleButton", ToggleButton);
    koruApp.component("Tree", Tree);
    koruApp.component("TreeSelect", TreeSelect);
    koruApp.component("TreeTable", TreeTable);
    koruApp.component("TriStateCheckbox", TriStateCheckbox);

    koruApp.component("KoruActionButton", KoruActionButton);
    koruApp.component("KoruAddress", KoruAddress);
    koruApp.component("KoruAddressMap", KoruAddressMap);
    koruApp.component("KoruBlock", KoruBlock);
    koruApp.component("KoruBreadcrumb", KoruBreadcrumb);
    koruApp.component("KoruBrowser", KoruBrowser);
    koruApp.component("KoruButtonUpload", KoruButtonUpload);
    koruApp.component("KoruContainer", KoruContainer);
    koruApp.component("KoruCurrencyField", KoruCurrencyField);
    koruApp.component("KoruEditor", KoruEditor);
    koruApp.component("KoruExpiration", KoruExpiration);
    koruApp.component("KoruFieldValue", KoruFieldValue);
    koruApp.component("KoruImageUpload", KoruImageUpload);
    koruApp.component("KoruLoading", KoruLoading);
    koruApp.component("KoruMap", KoruMap);
    koruApp.component("KoruMultipleUpload", KoruMultipleUpload);
    koruApp.component("KoruNumberField", KoruNumberField);
    koruApp.component("KoruPdfDialog", KoruPdfDialog);
    koruApp.component("KoruPercentField", KoruPercentField);
    koruApp.component("KoruPlaces", KoruPlaces);
    koruApp.component("KoruProgress", KoruProgress);
    koruApp.component("KoruSortableBrowser", KoruSortableBrowser);
    koruApp.component("KoruSplitButton", KoruSplitButton);
    koruApp.component("KoruTabbedViewer", KoruTabbedViewer);
    koruApp.component("KoruTinyBrowser", KoruTinyBrowser);
    koruApp.component("KoruTree", KoruTree);
    koruApp.component("KoruUpload", KoruUpload);
    koruApp.component("KoruViewer", KoruViewer);
  }
}
